module.exports = __webpack_public_path__ + "static/media/features-split-image-04.74429474.jpg";